module.exports = __webpack_public_path__ + "static/img/ywzn.3ede14c9.png";